import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  marginLeft: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", null, undefined]),
  maxWidth: PropTypes.string,
};

export default function ErrorMessage({ error, marginLeft, size, maxWidth }) {
  return (
    <AnimatePresence>
      {error && typeof error === "string" ? (
        <MotionDiv
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          $marginLeft={marginLeft}
          $size={size}
          $maxWidth={maxWidth}
        >
          <i
            className="far fa-exclamation-circle"
            style={{ marginTop: "3px" }}
          />{" "}
          {error}
        </MotionDiv>
      ) : null}
    </AnimatePresence>
  );
}

const MotionDiv = styled(motion.div)`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-left: ${(props) => props.$marginLeft || "36px"};
  max-width: ${(props) => props.$maxWidth || "360px"};
  font-size: ${(props) => (props.$size === "sm" ? "12px" : "14px")};
  color: #be353b;
`;
